import React, { useEffect, useState } from "react";
// import user from "../../assets/img/icons/user_3.svg";
// import book from "../../assets/img/icons/book.svg";
import { useTabs } from "../../hooks/lib/useTabs";
import {
  IAcademicsMenuCoursesData,
  IAcademicsMenuProgramsData,
  ISastDetailsBannerData,
} from "../../exports/interfaces";
import DegreeTile from "./DegreeTile";
import {
  fetchAcademicsMenuCourses,
  fetchAcademicsMenuPrograms,
} from "../../api/HomeApi";
import { dynamicFailed } from "../../hooks/custom/useToast";

const UndergraduateIntroBanner = (props: {
  sastDetailsBanner: ISastDetailsBannerData[];
}) => {
  useTabs();

  const [academicsMenuPrograms, setAcademicsMenuPrograms] = useState<
    IAcademicsMenuProgramsData[]
  >([]);
  const [academicsMenuCourses, setAcademicsMenuCourses] = useState<
    IAcademicsMenuCoursesData[]
  >([]);

  useEffect(() => {
    Promise.all([fetchAcademicsMenuPrograms(), fetchAcademicsMenuCourses()])
      .then(([academicsMenuProgramsData, AcademicsMenuCoursesData]) => {
        setAcademicsMenuPrograms(academicsMenuProgramsData);
        setAcademicsMenuCourses(AcademicsMenuCoursesData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      });
  }, []);

  const programs = academicsMenuPrograms.map((program) => {
    return {
      title: program.title,
      color: program.color_code,
      start_background_color: program.start_background_color,
      end_background_color: program.end_background_color,
      icon: program.icon_code,
      icon_image: program.icon_image,
      image: program.image,
      courses: academicsMenuCourses
        .filter((course) => course.program_name === program.title)
        .map((course) => course.name),
    };
  });

  return (
    <section>
      <div className="td_height_120 td_height_lg_40" />
      <div className="container">
        {/* <p>{props.sastDetailsBanner[0]?.description || ""}</p>

        <div className="td_height_30 td_height_lg_30"></div> */}

        <h2 className="td_card_title td_fs_24 td_semibold td_mb_32">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              fontWeight: "bold",
            }}
          >
            Undergraduate Programs
          </div>
        </h2>

        <div
          className="row td_gap_y_24"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "20px",
          }}
        >
          {programs.map((program, index) => (
            // <div key={course.id}>
            //   <div className="td_card td_style_5 ">
            //     <div className="td_card_thumb">
            //       <span className="td_card_thumb_in td_radius_10">
            //         <img src={course.thumb} alt={course.title} />
            //       </span>
            //     </div>
            //     <div className="td_card_content">
            //       <ul className="td_card_meta td_mp_0 td_fs_16 td_heading_color">
            //         <li>
            //           <img src={user} alt="User icon" />
            //           <span className="td_opacity_7">
            //             {course.seats} Seats
            //           </span>
            //         </li>
            //         <li>
            //           <img src={book} alt="Book icon" />
            //           <span className="td_opacity_7">
            //             {course.years} Years
            //           </span>
            //         </li>
            //       </ul>
            //       <h2 className="td_card_title td_fs_24 td_semibold td_mb_12">
            //         <div>{course.title}</div>
            //       </h2>

            //       <p className="td_section_subtitle td_fs_18 mb-12">
            //         {course.description}
            //       </p>
            //     </div>
            //   </div>
            // </div>

            <DegreeTile
              index={index}
              title={program.title}
              icon={program.icon}
              image={program?.image?.[0]?.media?.url}
              start_background_color={program.start_background_color}
              end_background_color={program.end_background_color}
              degrees={academicsMenuCourses?.filter(
                (course) => course.program_name === program.title,
              )}
              description="Bachelor of Science in Integrated Science balances intellectual breadth with analytical depth while remaining focused on Nepal's educational and societal priorities."
            />
          ))}
        </div>
      </div>

      <div className="td_height_112 td_height_lg_40" />
    </section>
  );
};

export default UndergraduateIntroBanner;
